import api from './api';

export function getProfile() {
    return dispatch => {
        dispatch({
            type: "FETCH_PROFILE",
            payload: api.get('/profile')
        })
    }
}

export function updateLastActivity() {
    return dispatch => {
        dispatch({
            type: "LAST_ACTIVITY",
            payload: api.put('/account/set-last-activity')
        })
    }
}